import { render } from "./IntroBtn.vue?vue&type=template&id=42c902c8&scoped=true"
import script from "./IntroBtn.vue?vue&type=script&lang=js"
export * from "./IntroBtn.vue?vue&type=script&lang=js"

import "./IntroBtn.vue?vue&type=style&index=0&id=42c902c8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c902c8"]])

export default __exports__